export default {
  pageTitle: 'Facilities',
  metaDescription: 'Explore TEF\'s manufacturing facilities and equipment, including cutting, forming, welding and heavy lifting machinery supporting large-scale fabrication projects.',
  hero: { title: 'Facilities' },
  manufacturing: {
    heading: 'Manufacturing Facilities',
    intro:
      'TEF operates advanced manufacturing facilities equipped with cutting-edge technology to ensure efficiency and precision in production.',
    table: {
      headers: {
        tools: 'TOOLS',
        dsc: 'DSC',
        edv: 'EDV',
        vyg: 'VYG',
        quantity: 'QUANTITY',
      },
      rows: {
        crane: 'Crane',
        hydraulicPress: 'Hydraulic Press Machine',
        ncPressBreak: 'NC Press Break Machines',
        rollsBending: 'Rolls Bending Rolling Machines',
        pipeBending: 'Pipe/Profile Bending Machine',
        weldingMachines: 'Welding Machines',
        cuttingMachines: 'Cutting Machines',
        machineTools: 'Machine Tools',
        mobileGenset: 'Mobile Genset & Mobile Compressor',
        inspectionTools: 'Inspection Tools',
        forklift: 'Forklift, Mobile Crane & Truck Crane',
      },
    },
    maxSize: {
      note: 'Maximum Size of Fabricated Products are limited by inland transportation.',
      maxDiameterLabel: 'Maximum diameter',
      maxDiameterValue: '6 meters',
      maxLengthLabel: 'Maximum Length',
      maxLengthValue: '30 meters approximately',
      overLimitNote: 'The product with over the maximum limit size will be negotiable.',
    },
  },
};
